import React from 'react';
import CustomerDetailSection from '../../../sections/AdminDashboard/UserManagement/CustomerDetail';

const CustomerDetail = () => {
  return <CustomerDetailSection />;
};

export default CustomerDetail;

